export default __webpack_public_path__ + "static/media/CloseButton.06113051.svg";